import type { Answer, ConversationContext } from '../types';
import { blocksToPlainText } from '../blocks/utils';

export const buildConversationContext = (answers: Answer[], conversationId?: string): ConversationContext => ({
  conversationId,
  messages: answers.map((a) => ({
    question: a.question,
    answer: blocksToPlainText(a.blocks),
  })),
});
